import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-homePortfolioSmallIcon",
  "use": "icon-homePortfolioSmallIcon-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol viewBox=\"0 0 48 48\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-homePortfolioSmallIcon\">\n<line x1=\"5\" y1=\"42.75\" x2=\"43\" y2=\"42.75\" stroke=\"#25282B\" stroke-width=\"2\" />\n<path d=\"M15.2075 14.5872L6.76709 25.0058V36L41.2322 35.5V26.9593L30.6817 17.843L25.0547 23.7034L15.2075 14.5872Z\" fill=\"#4570FB\" />\n<rect x=\"6\" y=\"6.75\" width=\"36\" height=\"29.814\" rx=\"1\" stroke=\"#25282B\" stroke-width=\"2\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/homePortfolioSmallIcon.svg
// module id = Hc7N
// module chunks = 10